(function(){
  var cart_disp = {
    config:{
      object:{},
      cart_items:$("tbody.cart"),
      cart_item_info: $("span.cart_items"),
      cart_price_info: $("span.cart_price"),
      cart_price_unit : "$",
      item_count : 1
    },
    init: function(obj){
    	cart_disp.config.object = obj;
      	
      	cart_disp.display();
        cart_disp.config.item_count =1;
    },
    disp: function(){
      
      Shopify.getCart(function(cart){
        $.each(cart.items,function(num,object){
          cart_disp.init(object);
          
          
        });
        cart_disp.disp_info();
      });
      
    },
    disp_info: function(){
      Shopify.getCart(function(cart_info){
      	var cart_items = cart_info.item_count,
            cart_price = cart_info.total_price/100;
        cart_disp.config.cart_item_info.empty().text(cart_items);
        cart_disp.config.cart_price_info.empty().text(cart_disp.config.cart_price_unit + cart_price);
      });
    },
    display: function(){

      var cart_items = cart_disp.config.cart_items,
      	item = cart_disp.config.object,
      	count = cart_disp.config.item_count,
      	tr=$("<tr></tr>",{class:"row"}).appendTo(cart_items);
      
      var title = item.title,
          id = item.id,
          image_url = item.image,
          price = item.price,
          quantity =item.quantity,
          image = $("<img>",{
            class:"img-responsive",
            src :image_url
          }),
          q_input = $("<input>",{
            min : 1,
            value : quantity,
            name : "quantity",
            type : "number",
            
          }).attr("data-id",id).on("change",function(){
          	var data_id = $(this).data("id"),
                value = $(this).val();
            	Shopify.changeItem(data_id,value);
            	cart_disp.disp_info();
            
          });
      
      $("<td></td>",{
        class:"count col-xs-1",
        text: count
      }).appendTo(tr);
        
      $("<td></td>",{
        class:"image col-xs-2",
      }).appendTo(tr).append(image);
      
      $("<td></td>",{
        class: "title col-xs-2",
        text:title
      }).appendTo(tr);
      
      $("<td></td>",{
        class : "price col-xs-2",
        text : price
      }).appendTo(tr);
      
      $("<td></td>",{
        class: "quantity col-xs-3"
      }).appendTo(tr).append(q_input);
      
      $("<td></td>",{
        class : "remove col-xs-2a",
        text : "X",
        value : id
      }).appendTo(tr).css("cursor","pointer")
      .on("click",function(){
      	var remove_id = $(this).attr("value");
        Shopify.removeItem(remove_id);
      	$(this).closest("tr").remove();
        
        cart_disp.disp_info();
      });
                    
      
      
      
      
      
    }
    
  };
  
  
 
  
  
  //function for cart popup displaying
  var body = $("body");
  var cart_popup = $("div#cart-popup").css("z-index","10").hide();
  var addBtn = $("button#add-to-cart");
  
  
  var mirror = $("<div></div>").prependTo(body)
  .css({
    "width": "100%",
    "postion":"fixed",
    "height": "100vh",
    "opacity" :"0.5",
    "background":"black",
    "width": "100%",
    "z-index":"2",
    "position":"fixed"
  }).hide();
  
  $("button.close-cart").on("click",function(){
      cart_popup.slideUp(400);
      mirror.fadeOut(400);
  });
  addBtn.on("click",function(e){
    var product_id= $("#product-value").val();
    e.preventDefault();
    $("tbody.cart").empty();
     Shopify.addItem(product_id,1);
   
    
    	cart_disp.disp();
      cart_popup.slideDown(400);
    
      mirror.fadeIn(400);
   
  });	
  
  //overriding the shopify object
  Shopify.onCartUpdate = function(cart) {
  console.log('There are now ' + cart.item_count + ' items in the cart.');
    
};  
 Shopify.onCartShippingRatesUpdate = function(rates, shipping_address) {
  var readable_address = '';
  if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
  if (shipping_address.province) readable_address += shipping_address.province + ', ';
  readable_address += shipping_address.country
  console.log('There are ' + rates.length + ' shipping rates available for ' + readable_address +', starting at '+ Shopify.formatMoney(rates[0].price) +'.');
}; 
  Shopify.onItemAdded = function(line_item) {
  console.log(line_item.title + ' was added to your shopping cart.');
};

Shopify.onProduct = function(product) {
  console.log('Received everything we ever wanted to know about ' + product.title);
};

})();